if (!customElements.get('recharge-compare-at-prices')) {
  customElements.define(
    'recharge-compare-at-prices',
    class extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('section');
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        this.widgets = new Map();
        this.onChange = () => this.updatePrices();
        this.section.addEventListener('change', this.onChange);
        this.sectionObserver = new MutationObserver(() => this.findWidgets());
        this.sectionObserver.observe(this.section, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['default-variant-id'],
        });
        this.findWidgets();
      }

      disconnectedCallback() {
        this.section.removeEventListener('change', this.onChange);
        this.sectionObserver.disconnect();
        this.widgets.forEach((observer) => observer.disconnect());
        clearTimeout(this.shadowRootTimer);
      }

      findWidgets() {
        clearTimeout(this.shadowRootTimer);
        for (const [widget, observer] of this.widgets) {
          if (!this.section.contains(widget)) {
            observer.disconnect();
            this.widgets.delete(widget);
          }
        }

        let waitingForShadowRoot = false;
        this.section.querySelectorAll('recharge-subscription-widget').forEach((widget) => {
          if (widget.getAttribute('product-id') !== this.dataset.productId || this.widgets.has(widget)) return;
          if (!widget.shadowRoot) {
            waitingForShadowRoot = true;
            return;
          }

          const observer = new MutationObserver(() => this.updateWidget(widget));
          observer.observe(widget.shadowRoot, { childList: true, subtree: true, characterData: true });
          this.widgets.set(widget, observer);
        });
        this.updatePrices();

        // Attaching a shadow root does not trigger the section's MutationObserver.
        if (waitingForShadowRoot) {
          this.shadowRootTimer = setTimeout(() => this.findWidgets(), 100);
        }
      }

      updatePrices() {
        this.widgets.forEach((observer, widget) => this.updateWidget(widget));
      }

      updateWidget(widget) {
        const input = this.section.querySelector(`#${CSS.escape(this.dataset.formId)} [name="id"]`);
        const variantId = input?.value || widget.getAttribute('default-variant-id') || this.dataset.variantId;
        const variant = this.variants[variantId];
        const root = widget.shadowRoot;

        if (!root.querySelector('[data-theme-compare-at-style]')) {
          const style = document.createElement('style');
          style.setAttribute('data-theme-compare-at-style', '');
          style.textContent = `
            [data-theme-compare-at-price] {
              margin-inline-start: 0.5em;
              font-size: 1em;
              font-weight: normal;
              white-space: nowrap;
            }
          `;
          root.append(style);
        }

        root.querySelectorAll('[part~="rc-purchase-option__prices"]').forEach((prices) => {
          let compareAtPrice = prices.querySelector('[data-theme-compare-at-price]');
          if (!variant?.on_sale) {
            compareAtPrice?.remove();
            return;
          }

          if (!compareAtPrice) {
            compareAtPrice = document.createElement('s');
            compareAtPrice.setAttribute('data-theme-compare-at-price', '');
            prices.append(compareAtPrice);
          }

          if (compareAtPrice.textContent !== variant.compare_at_price) {
            compareAtPrice.textContent = variant.compare_at_price;
            compareAtPrice.setAttribute('aria-label', `${this.dataset.priceLabel}: ${variant.compare_at_price}`);
          }
        });
      }
    },
  );
}
